import React from "react";
import { Card, Box, Typography, Rating } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  const price = product?.price || 0;
  const mrp = product?.mrp || price;
  const discount =
    mrp > price ? Math.round(((mrp - price) / mrp) * 100) : 0;

  return (
    <Card
      onClick={() => navigate(`/product/${product._id}`)}
      sx={{
        cursor: "pointer",
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: 1,
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: 4,
          transform: "translateY(-2px)",
        },
      }}
    >
      {/* 🔹 IMAGE */}
      <Box
        sx={{
          position: "relative",
          height: 200,
          backgroundColor: "#f7f7f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
        }}
      >
        <img
          src={product?.thumbnailUrl || "/placeholder-product.png"}
          alt={product?.title}
          style={{
            maxHeight: "100%",
            maxWidth: "100%",
            objectFit: "contain",
          }}
        />

        {/* 🔥 DISCOUNT BADGE */}
        {discount > 0 && (
          <Box
            sx={{
              position: "absolute",
              top: 8,
              left: 8,
              backgroundColor: "#cc0c39",
              color: "#fff",
              fontSize: 12,
              fontWeight: 600,
              px: 1,
              py: 0.3,
              borderRadius: 1,
            }}
          >
            {discount}% OFF
          </Box>
        )}
      </Box>

      {/* 🔹 CONTENT */}
      <Box sx={{ p: 1.5 }}>
        {/* TITLE */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            height: 40,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {product?.title}
        </Typography>

        {/* ⭐ RATING */}
        <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
          <Rating
            value={product?.rating || 0}
            precision={0.5}
            size="small"
            readOnly
          />
          <Typography sx={{ fontSize: 12, ml: 0.5 }}>
            ({product?.ratingCount || 0})
          </Typography>
        </Box>

        {/* 💰 PRICE */}
        <Box sx={{ mt: 1 }}>
          <Typography
            variant="body1"
            sx={{ fontWeight: 600, color: "#B12704" }}
          >
            ₹{price}
          </Typography>

          {mrp > price && (
            <Typography
              variant="body2"
              sx={{
                textDecoration: "line-through",
                color: "#555",
                fontSize: 12,
              }}
            >
              ₹{mrp}
            </Typography>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default ProductCard;